module.exports = __webpack_public_path__ + "static/media/lesson upload.9de257d7.svg";